import {Injectable} from '@angular/core';
import {DialogModalComponent} from './dialog-modal/dialog-modal.component';
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {environment} from "../../../environments/environment";
import Swal from 'sweetalert2'
import {of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(private modalService: NgbModal) {
    }

    open(message: string, messageType: string, classes: string, iconClass: string, isConfirmation: boolean = false): Promise<any> {


        const dialogModal = this.modalService.open(DialogModalComponent, {centered: true});


            dialogModal.componentInstance.message = message;
            dialogModal.componentInstance.class = classes;
            dialogModal.componentInstance.messageType = messageType;
            dialogModal.componentInstance.iconClass = iconClass;
            dialogModal.componentInstance.isConfirmation = isConfirmation;
            return dialogModal.result.then((result) => {
                return result; // User confirmed
            }, (reason) => {
                if (reason === ModalDismissReasons.ESC) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
                return false; // User dismissed
            });

    }

    openInvalidFormDialog() {
        this.open('Demande erronée. Veuillez vérifier votre saisie et la soumettre à nouveau!', environment.error_message_type, 'danger', environment.error_icon).finally();
    }

    openSuccessDialog(message: string) {
        this.openSuceessAlert(message)
    }

    openDangerDialog(message: string) {
        this.open(message, environment.error_message_type, 'danger', environment.error_icon).finally()
    }

    confirm(message: string): Promise<boolean> {
        return this.open(message, environment.warning_message_type, 'danger', environment.warning_icon, true);
    }

    openSuceessAlert(message: string) {
        Swal.fire({
            title: "Operation réussie!",
            text: message,
            icon: "success",
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
    `
            },
            hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
    `
            },
            showConfirmButton: false,
            timer: 1500,

        }).finally()
    }

    openSuceessAlertWithoutMess() {
        Swal.fire({
            icon: "success",
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
    `
            },
            hideClass: {
                popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
    `
            },
            showConfirmButton: false,
            timer: 1500,

        }).finally()
    }


    openDangerAlert(message: string) {
        Swal.fire({
            icon: "error",
            title: "Demande erronée!",
            text: message,
            showConfirmButton: false,

        }).finally()
    }

    openQuestionAlert(message: string) {
        Swal.fire({
            icon: "question",
            title: "Demande invalide!",
            text: message,
            showConfirmButton: false,
        }).finally()
    }


    openInfoAlert(message: string) {
        Swal.fire({
            icon: "info",
            html: message,
            showConfirmButton: false,
        }).finally();
    }
    openCustomDialog(title: string, htmlContent: string): Promise<void> {
        // Ici on enlève les balises HTML pour affichage propre dans alert (exemple simple)
        const textContent = htmlContent.replace(/<[^>]+>/g, '');
      
        // Affiche une simple boîte d'alerte
        alert(`${title}\n\n${textContent}`);
      
        // Promise résolue immédiatement (simule fermeture dialog)
        return Promise.resolve();
      }
      
      closeCustomDialog() {
        // Si modal réel : tu écris ici la logique pour fermer la fenêtre modale
        // ex: this.dialogRef.close();
      }
      

}
